import Store from 'lightningjs-redux';
import { getSubtitleCuePoint, isContentMode } from '../../logic/player/player.selectors';

const mapControllers = instance => ({
  subtitleCuePoint: {
    selector: getSubtitleCuePoint,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.updateSubtitles(value);
    },
  },
  isContentMode: {
    selector: isContentMode,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.visible = value;
    },
  },
});

export default Store.control(mapControllers);
